// extracted by mini-css-extract-plugin
export default {"successful-reset-wrapper":"SuccessfulReset_successful-reset-wrapper__Emc+D"};